// @flow

import { SHOT_ACTIONS, SHOT_CONDITIONS } from "../consts/constants"
import type { PaxPossibleCondition, ValuesForDeterminingCondition } from "./PropTypes"

export const scheduleChangesConditions: ValuesForDeterminingCondition => PaxPossibleCondition = ({
  action,
  flightsChecked,
  isGuaranteeValid,
  hasAlternatives,
  isRefund,
  scheduleChangeCase,
  isViewAlternatives,
  isShotEmergencyExpired,
}: ValuesForDeterminingCondition) => {
  if (!flightsChecked && isViewAlternatives) return SHOT_CONDITIONS.SEARCHING
  if (action === SHOT_ACTIONS.WAIT) return SHOT_CONDITIONS.WAIT
  if (action === SHOT_ACTIONS.INFO) return SHOT_CONDITIONS.MINOR_DELAY
  if (action === SHOT_ACTIONS.AERO) return SHOT_CONDITIONS.NON_GUARANTEE
  if (action === SHOT_ACTIONS.CS) return SHOT_CONDITIONS.CONTACT_US
  if ((hasAlternatives || isRefund) && isGuaranteeValid && action === SHOT_ACTIONS.KIWI)
    return SHOT_CONDITIONS.OFFERS_WITHOUT_ACCOMMODATION
  if ((hasAlternatives || isRefund) && isGuaranteeValid && action !== SHOT_ACTIONS.KIWI)
    return SHOT_CONDITIONS.OFFERS
  if (isShotEmergencyExpired) return SHOT_CONDITIONS.EXPIRED_EMERGENCY
  if (!isGuaranteeValid && (hasAlternatives || !flightsChecked))
    return SHOT_CONDITIONS.EXPIRED_WITH_ALTERNATIVES
  if (!isGuaranteeValid && flightsChecked && !hasAlternatives)
    return SHOT_CONDITIONS.EXPIRED_WITH_NO_ALTERNATIVES
  if (scheduleChangeCase === "inProgress") return SHOT_CONDITIONS.CONTACT_US
  return SHOT_CONDITIONS.OFFERS
}
